import { format, parseISO } from 'date-fns';
import { useEffect } from 'react';

import { Alert, Box, Card, CardContent, Stack } from '@mui/material';
import { Legend, LineChart, Text, Title } from '@zippeditoolsjs/dashboards';

import ChipGroup from './ChipGroup';

export default function LineChartCard(props) {
  const {
    sx,
    title = 'Cycles',
    subtitle = 'Analysis of the behavior of the cycles',
    lineData,
    inputIndex = 'index',
    inputCategories = ['movements'],
    inputColors = ['teal'],
    filterVariant = 'chip',
    isLoading = false,
    timeFrame,
    setTimeFrame,
    noDataText = 'No data',
  } = props;

  useEffect(() => {
    if (lineData)
      lineData.forEach((element) => {
        element.timestamp = format(
          parseISO(`${element.timestamp}Z`),
          'yyyy-MM-dd HH:mm:ss'
        );
      });
  }, [lineData]);

  // Real data exists only if a point has a non-null value for the category.
  const hasData = lineData?.some((point) =>
    inputCategories.some((category) => point[category] != null)
  );

  return (
    <Card sx={{ mt: 2, ...sx }}>
      <CardContent>
        <Stack spacing={2}>
          <Box className="text-center">
            <Title>{title}</Title>
            <Text className="text-center">{subtitle}</Text>
          </Box>

          {filterVariant === 'chip' ? (
            <ChipGroup
              disabled={isLoading}
              timeFrame={timeFrame}
              setTimeFrame={setTimeFrame}
              optionTimes={[
                { label: '1 hours', deltaTime: 1 },
                { label: '3 hours', deltaTime: 3 },
                { label: '6 hours', deltaTime: 6 },
                { label: '12 hours', deltaTime: 12 },
                { label: '1 day', deltaTime: 24 },
              ]}
              color="info"
              size="small"
            />
          ) : null}

          {hasData ? (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Legend categories={inputCategories} colors={inputColors} />
              </Box>
              <LineChart
                className="h-80"
                data={lineData}
                index={inputIndex}
                categories={inputCategories}
                colors={inputColors}
                showLegend={false}
                yAxisWidth={48}
              />
            </>
          ) : (
            <Alert severity="info">{noDataText}</Alert>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
